import React, { FC } from "react";

import { Avatar, AvatarProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  border: "1px solid rgba(0, 0, 0, 0.12)",
}));

export interface IgAvatarProps extends AvatarProps {
  border?: boolean;
  size?: "medium" | "small";
}

/**
 * @see Avatar
 */
export const IgAvatar: FC<IgAvatarProps> = (props) => {
  const { children, border, sx, size, ...rest } = props;

  if (border) {
    return (
      <StyledAvatar
        sx={{
          ...(size === "small" && {
            width: "24px",
            height: "24px",
          }),
          ...sx,
        }}
        variant={props.variant || "rounded"}
        {...rest}
      >
        {children}
      </StyledAvatar>
    );
  }

  return (
    <Avatar
      variant={props.variant || "rounded"}
      sx={{
        ...(size === "small" && {
          width: "24px",
          height: "24px",
        }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Avatar>
  );
};
